import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Sector } from "@modules/bookSectors/types";
import { SectorFormValues } from "@modules/bookSectors/validations";

import { createSectorService } from "./service";
import { UseCreateSectorMutationOptions } from "./types";

export function useCreateSectorMutation(
  options?: UseCreateSectorMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Sector, ApiError, SectorFormValues>({
    mutationFn: createSectorService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
